import { IRapportInfo } from '../../../../../Types/RapportInfoType';
import { rapportInfos } from '../RapportInfo';

const BJRapportMeny: IRapportInfo[] = [rapportInfos.BJEtikett];

export default BJRapportMeny;
